import axios from 'axios';
import { HOST } from '../../domain/http'

const register = async (body) => axios({
    method: 'POST',
    headers: { "Content-Type": "application/json" },
    url: `${HOST}/ajax.php?accion=crearWalletKitQR`,
    data: { ...body, __nonce: "pzj5n3y2" },
});

const retrieve = async (body) => {

    const cs = await axios({
        method: 'POST',
        headers: { "Content-Type": "application/json" },
        url: `${HOST}/ajax.php?accion=getInfoCriptos`,
        data: body,
    });

    if (cs.status === 202 || cs.status === 200) {
        let data = [];
        for (const key in cs.data) data.push(cs.data[key]);
        return new Promise((resolve) => resolve({ data, status: 200 }));
    }
    else return new Promise((resolve) => resolve({ data: cs.data, status: 400 }));
}

export { register, retrieve };